import React from 'react'
import { Typography, Card } from '../../../_atoms'
import { Stack } from '../../../_layouts'
import { useCandidateChat } from '../CandidateChatContext'
import useTranslation from '../../../shared/TranslationProvider'

/**
 * WaitingForCoach component - displays when waiting for coach to accept the chat
 * This should only show when the coach hasn't accepted yet, not after connection
 * Implements user type specific messaging based on section 7 of react_component_mapping.md
 */
const WaitingForCoach = () => {
  const { t } = useTranslation('coach_chat')
  const {
    deloitteUser = false,
    userCareerDevelopment = false,
    selectedCoach,
    getDarkModeClasses,
  } = useCandidateChat()

  // Determine title based on user type - matches section 7 logic
  const getWaitingTitle = () => {
    if (deloitteUser) {
      return t('loading_states.contacting_advisor_title', {
        defaultValue: 'Contacting Advisor',
      })
    } else if (userCareerDevelopment) {
      return t('loading_states.starting_a_chat', {
        defaultValue: 'Starting a Chat',
      })
    } else {
      return t('loading_states.contacting_coach_title', {
        defaultValue: 'Contacting Coach',
      })
    }
  }

  // Determine message based on user type and coach name
  const getWaitingMessage = () => {
    const coachName = selectedCoach?.displayName || 'your coach'
    const baseMessage = t(
      'loading_states.contacting_coach_message',
      'Please wait while we contact',
    )

    return `${baseMessage} ${coachName}...`
  }

  return (
    <div
      id="waiting_for_coach"
      className={`flex flex-1 flex-col items-center justify-center px-4 py-8 ${getDarkModeClasses('bg-white', 'bg-gray-800')}`}
      style={{ height: '100%', width: '100%' }}
    >
      <Card
        className={`max-w-md ${getDarkModeClasses('border-gray-200 bg-white', 'border-gray-600 bg-gray-700')}`}
        style={{ width: '100%' }}
      >
        <Stack spacing={4}>
          <div className="flex flex-col items-center">
            <img
              src="https://yns-com.s3.amazonaws.com/images/chat/chat_loading.gif"
              alt="loading"
              className="h-8 w-8"
            />
            <Typography
              variant="title4"
              className={getDarkModeClasses('text-gray-900', 'text-white')}
            >
              {getWaitingTitle()}
            </Typography>
          </div>
          <Typography
            variant="body"
            className={getDarkModeClasses('text-gray-700', 'text-gray-300')}
          >
            {getWaitingMessage()}
          </Typography>
        </Stack>
      </Card>
    </div>
  )
}

export default WaitingForCoach
